import type { CSSProperties } from 'react';

/** Gold, silver and bronze discs of the top three (Figma 15001:34571 / 34580 / 34589). */
const PLACE_COIN_STYLE: Record<number, CSSProperties> = {
  1: {
    backgroundImage:
      'linear-gradient(174.69deg, rgb(255, 221, 129) 15.76%, rgb(128, 98, 16) 59.45%, rgb(145, 118, 28) 108.24%)',
  },
  2: {
    backgroundImage:
      'linear-gradient(174.69deg, rgb(240, 242, 247) 15.76%, rgb(88, 94, 103) 59.45%, rgb(148, 153, 166) 108.24%)',
  },
  3: {
    backgroundImage:
      'linear-gradient(174.69deg, rgb(255, 191, 148) 15.76%, rgb(103, 52, 21) 59.45%, rgb(153, 89, 48) 108.24%)',
  },
};

interface PlaceCoinProps {
  place: number;
}

/** A top-three place as a numbered metal disc. */
export function PlaceCoin({ place }: PlaceCoinProps) {
  return (
    <span
      className="flex size-5 shrink-0 items-center justify-center rounded-full text-center text-[12px] leading-4 tracking-[-0.12px] text-white tabular-nums"
      style={PLACE_COIN_STYLE[place]}
    >
      {place}
    </span>
  );
}
